import { VStack } from "@chakra-ui/react"
import React from "react"
import { UnassignPhoneDeviceForm } from "../../forms"
import { ExtendedUserFragment } from "../../graphql"

export type UnassignPhoneDeviceProps = {
	user: ExtendedUserFragment
}

export const UnassignPhoneDevice: React.FC<UnassignPhoneDeviceProps> = ({ user }) => {
	return (
		<VStack w="full" spacing={6} maxW="sm">
			<UnassignPhoneDeviceForm user={user} />
		</VStack>
	)
}
